export default "__VITE_ASSET__e2eae231__"